<template>
    <div class="box-typical-body panel-body">
        <div v-if="_.isEmpty(reportData)" :class="['alert', 'alert-info', 'm-0']">
            {{ 'No result' }}
        </div>
        <table v-else class="table table-dashboard">
            <thead>
                <tr>
                    <th v-for="field in fields" :key="field.name">
                        <div class="pl-1">{{ field.label }}</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-on:click="gotoItem(item.id)"
                    v-for="item in reportDataHtml"
                    :key="item.id"
                    class="clickable">
                    <td v-for="key in _.keys(fields)" v-html="_.get(item, key, '')" :key="key"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script charset="utf-8">
export default {
    data() {
        const types = [
            // 'processed',
            // 'delivered',
            'open',
            'unique_open',
            'click',
            'unique_click',
            // 'deferred',
            'bounce',
            // 'dropped',
            // 'unsubscribe',
            // 'spamreport',
        ];

        return {
            types,
            selectedTypes: [
                ...types
            ],
        }
    },

    props: ['reports'],

    components: {

    },

    computed: {
        fields() {
            return {
                reported_at: {
                    label: 'Date',
                    value: (val, data, __) => `<p class="small">${val}</p>`,
                },
                delivered: {
                    label: 'Delivered',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                open: {
                    label: 'Open',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                unique_open: {
                    label: 'Unique Open',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                click: {
                    label: 'Click',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                unique_click: {
                    label: 'Unique Click',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                bounce: {
                    label: 'Bounce',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
                dropped: {
                    label: 'Dropped',
                    value: (val, data) => `<span class="">${val || 0}</span>`,
                },
            };
        },
        reportData() {
            return _.chain(this.reports)
                .map(item => {
                    return {
                        id: item.id, type: item.type,
                        ...(item.attributes),
                        ...(item.meta),
                    }
                })
                .value();
        },
        reportDataHtml() {
            return _.chain(this.reportData)
                .map(this.formatItemData)
                .value();
        },
    },

    methods: {
        formatItemData(attributes) {
            const keys = _.keys(this.fields);
            const simplyReturn = (val) => val;

            return _.chain(attributes)
                .toPairs()
                .reduce((tmp, [key, rawValue]) => {
                    if (keys.indexOf(key) < 0) {
                        return tmp;
                    }

                    const handler = _.get(this.fields, [key, 'value'], simplyReturn);
                    return { ...tmp, [key]: handler(rawValue, attributes, this.__, this._) }
                }, {})
                .value();
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/report/CampaignTableComponent.vue